import { Check } from "lucide-react";
import { Reveal, Overline, SectionTitle } from "./Reveal";
import { OpenAppButton, WaitlistButton } from "./Buttons";

const INCLUDED = ["Weekly workout plan", "225 exercises with videos and form tips", "Shared plan with your gym buddy", "Food diary and barcode scanner", "Meal plan and shopping list", "Weigh-ins and progress photos"];

export const Pricing = () => (
  <section id="pricing" className="border-t border-white/[0.07] bg-[#0b0c0f]">
    <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-36">
      <Reveal className="max-w-3xl"><Overline>Pricing</Overline><SectionTitle className="mt-4">Your free<br /><span className="text-grad">gym buddy.</span></SectionTitle></Reveal>
      <div className="mt-14">
        <Reveal>
          <div data-testid="pricing-free-plan-card" className="relative h-full overflow-hidden rounded-[2rem] border border-[#ff6a3d]/40 bg-[#16181f] p-8 md:p-12">
            <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#ff6a3d]/25 blur-[100px]" />
            <span className="relative rounded-full bg-[#ff6a3d]/15 px-3 py-1 font-mono-x text-[11px] uppercase tracking-widest text-[#ff8a3d]">Everything included</span>
            <div className="relative mt-6 flex items-end gap-3">
              <span className="font-display text-8xl font-black leading-none sm:text-9xl">Free</span>
              <span className="mb-3 text-[#b3b8c1]">No ads. No card. No catch.</span>
            </div>
            <ul className="relative mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {INCLUDED.map((f) => (
                <li key={f} className="flex items-center gap-3 text-sm text-[#e4e6ea]"><span className="flex h-5 w-5 items-center justify-center rounded-full bg-grad text-[#1a0b05]"><Check className="h-3 w-3" /></span>{f}</li>
              ))}
            </ul>
            <div className="relative mt-10 flex flex-col gap-3 sm:flex-row">
              <OpenAppButton testId="pricing-open-app-btn" label="Start free now" />
              <WaitlistButton testId="pricing-waitlist-btn" label="Notify me at launch" />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
